/* ---------------------------------------------------------------
   Sconto di benvenuto Breeze - multilingua (IT / DE / ES / EN).
   Per cambiare codici o testi basta modificare questa tabella.
--------------------------------------------------------------- */
const BREEZE_WELCOME_I18N = {
  it: {
    code: 'BENVENUTO5',
    title: 'Iscrizione completata!',
    text: 'Ecco il tuo codice per il 5% di sconto. Inseriscilo nel carrello alla voce "Sconto".',
    hint: 'Tocca il codice per copiarlo',
    copied: 'Codice copiato!'
  },
  de: {
    code: 'WILLKOMMEN5',
    title: 'Anmeldung abgeschlossen!',
    text: 'Hier ist Ihr Code für 5 % Rabatt. Geben Sie ihn im Warenkorb unter "Rabatt" ein.',
    hint: 'Tippen Sie auf den Code, um ihn zu kopieren',
    copied: 'Code kopiert!'
  },
  es: {
    code: 'BIENVENIDO5',
    title: '¡Suscripción completada!',
    text: 'Aquí tienes tu código con un 5% de descuento. Introdúcelo en el carrito, en el apartado "Descuento".',
    hint: 'Toca el código para copiarlo',
    copied: '¡Código copiado!'
  },
  en: {
    code: 'BENVENUTO5',
    title: 'You are subscribed!',
    text: 'Here is your 5% discount code. Enter it in the cart under "Discount".',
    hint: 'Tap the code to copy it',
    copied: 'Code copied!'
  }
};

function breezeWelcome() {
  const raw =
    (window.Shopify && window.Shopify.locale) ||
    document.documentElement.getAttribute('lang') ||
    'it';
  const lang = String(raw).slice(0, 2).toLowerCase();
  return BREEZE_WELCOME_I18N[lang] || BREEZE_WELCOME_I18N.it;
}

function breezeRewardStyles() {
  if (document.getElementById('breeze-reward-styles')) return;
  const style = document.createElement('style');
  style.id = 'breeze-reward-styles';
  style.textContent = [
    '.breeze-reward{text-align:center;padding:4px 0 2px}',
    '.breeze-reward__title{font-weight:700;margin:0 0 6px;font-size:17px}',
    '.breeze-reward__text{margin:0 0 14px;font-size:14px;line-height:1.45;opacity:.85}',
    '.breeze-reward__code{display:inline-block;font-family:ui-monospace,Menlo,monospace;',
    'font-size:20px;font-weight:700;letter-spacing:.12em;padding:12px 22px;',
    'border:2px dashed currentColor;border-radius:8px;background:transparent;',
    'color:inherit;cursor:pointer;line-height:1}',
    '.breeze-reward__code:hover{opacity:.75}',
    '.breeze-reward__hint{display:block;margin-top:10px;font-size:12.5px;opacity:.7}'
  ].join('');
  document.head.appendChild(style);
}

function breezeBuildReward() {
  breezeRewardStyles();
  const W = breezeWelcome();

  const wrap = document.createElement('div');
  wrap.className = 'breeze-reward';

  const title = document.createElement('p');
  title.className = 'breeze-reward__title';
  title.textContent = W.title;

  const text = document.createElement('p');
  text.className = 'breeze-reward__text';
  text.textContent = W.text;

  const code = document.createElement('button');
  code.type = 'button';
  code.className = 'breeze-reward__code';
  code.textContent = W.code;

  const hint = document.createElement('span');
  hint.className = 'breeze-reward__hint';
  hint.textContent = W.hint;

  code.addEventListener('click', function () {
    const done = function () {
      hint.textContent = W.copied;
      setTimeout(function () { hint.textContent = W.hint; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(W.code).then(done, function () {});
    } else {
      const tmp = document.createElement('textarea');
      tmp.value = W.code;
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(tmp);
    }
  });

  wrap.appendChild(title);
  wrap.appendChild(text);
  wrap.appendChild(code);
  wrap.appendChild(hint);
  return wrap;
}

class SubscriptionModal extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieKey = 'subscription-modal';

    this.states = {
      bodyActive: 'modal-open',
      visible: 'is-visible',
      hiding: 'is-hiding',
      imageVisible: 'has-image'
    };

    this.modal = this.querySelector('.modal-wrapper');

    if (this.querySelector('.form__note')) {
      this.show();
    }

    this.querySelectorAll('[data-modal-toggle]').forEach((btn) =>
      btn.addEventListener('click', this.handleToggle.bind(this))
    );

    this.setupWelcomeCode();

    if (!this.getCookie(this.cookieKey) || this.dataset.testMode === 'true') {
      this.start();
    } else if (window.BreezeUX) {
      window.BreezeUX.popupSkipped();
    }
  }

  /* Dopo l'iscrizione Shopify ricarica la pagina e il tema mostra un messaggio
     di conferma. Qui lo sostituiamo con il codice sconto e riapriamo il popup.
     Nessuna intercettazione del form: la protezione CAPTCHA di Shopify richiede
     che l'invio avvenga in modo nativo. */
  setupWelcomeCode() {
    const serverNote = this.querySelector('.subscription-form__note--success');
    if (!serverNote) return;
    serverNote.replaceWith(breezeBuildReward());
    this.show();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onLoadHandler = this.handleLoad.bind(this);
      this.onSelectHandler = this.handleSelect.bind(this);
      this.onDeselectHandler = this.handleDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onLoadHandler);
      document.addEventListener('shopify:section:select', this.onSelectHandler);
      document.addEventListener('shopify:section:deselect', this.onDeselectHandler);
    }
  }

  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onLoadHandler);
      document.removeEventListener('shopify:section:select', this.onSelectHandler);
      document.removeEventListener('shopify:section:deselect', this.onDeselectHandler);
      document.body.classList.remove(this.states.bodyActive);
    }
  }

  handleLoad(event) {
    this.filterEvent(event, this.show.bind(this));
  }

  handleSelect(event) {
    this.filterEvent(event, this.show.bind(this));
  }

  handleDeselect(event) {
    this.filterEvent(event, this.hide.bind(this));
  }

  start() {
    if (Shopify && Shopify.designMode) return;
    if (this.dataset.disabled === 'true') {
      if (window.BreezeUX) window.BreezeUX.popupSkipped();
      return;
    }
    /* Breeze CRO: il popup parte solo quando il banner cookie e' chiuso,
       dopo il ritardo impostato e dopo un po' di scroll (vedi snippet breeze-ux). */
    if (window.BreezeUX) {
      window.BreezeUX.whenPopupAllowed(() => this.show(), this.dataset.delay);
      return;
    }
    setTimeout(() => this.show(), parseInt(this.dataset.delay) * 1000);
  }

  handleToggle(event) {
    event.preventDefault();
    this.modal.classList.contains(this.states.visible) ? this.hide() : this.show();
  }

  show() {
    if (window.BreezeUX) window.BreezeUX.popupOpened();
    document.body.classList.remove(this.states.bodyActive);
    this.modal.classList.add(this.states.visible);
    setTimeout(() => this.modal.classList.add(this.states.imageVisible), 500);

    if (this.modal.dataset.placement === 'center') {
      document.body.classList.add(this.states.bodyActive);
    }
  }

  hide() {
    if (window.BreezeUX) window.BreezeUX.popupClosed();
    this.modal.classList.add(this.states.hiding);
    setTimeout(() => {
      this.modal.classList.remove(this.states.visible);
      this.modal.classList.remove(this.states.hiding);
      this.modal.classList.remove(this.states.imageVisible);

      if (this.modal.dataset.placement === 'center') {
        document.body.classList.remove(this.states.bodyActive);
      }
    }, 400);

    if (this.dataset.testMode === 'true') {
      this.clearCookie(this.cookieKey);
      return;
    }

    this.storeCookie(this.cookieKey, this.dataset.expiry);
  }

  getCookie(key) {
    const cookie = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
    return cookie ? cookie[2] : null;
  }

  storeCookie(key, days) {
    document.cookie = `${key}=true; max-age=${days * 24 * 60 * 60}; path=/`;
  }

  clearCookie(key) {
    document.cookie = `${key}=; max-age=0; path=/`;
  }

  filterEvent(event, callback) {
    let shouldRun = false;
    if (event.type.includes('shopify:section')) {
      if (
        this.hasAttribute('data-section-id') &&
        this.getAttribute('data-section-id') === event.detail.sectionId
      ) {
        shouldRun = true;
      }
    }
    if (shouldRun) callback(event);
  }
}

customElements.define('subscription-modal', SubscriptionModal);

